// extracted by mini-css-extract-plugin
export default {"aboveHeaderSlot":"C7YyP5"};